<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_nom">Nom et Postnom</label>
        <label class="input-group-text" for="joueur_postnom"></label>
      </div>
      <input id="joueur_nom"
             v-model="dataForm.nom"
             class="form-control"
             name="joueur_nom"
             placeholder="Entrez le nom du joueur"
             type="text">
      <input id="joueur_postnom"
             v-model="dataForm.postnom"
             class="form-control"
             name="joueur_postnom"
             placeholder="Entrez le postnom du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label id="prenom" class="input-group-text" for="joueur_prenom">Prénom</label>
      </div>
      <input id="joueur_prenom"
             v-model="dataForm.prenom"
             class="form-control"
             name="joueur_prenom"
             placeholder="Entrez le prenom du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label id="poste" class="input-group-text" for="joueur_poste">Poste</label>
      </div>
      <input id="joueur_poste"
             v-model="dataForm.poste"
             class="form-control"
             name="joueur_poste"
             placeholder="Entrez le poste du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label id="taille" class="input-group-text" for="joueur_taille">Taille</label>
      </div>
      <input id="joueur_taille"
             v-model="dataForm.taille"
             class="form-control"
             name="joueur_taille"
             placeholder="Entrez la taille du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label id="poids" class="input-group-text" for="joueur_poids">Poids</label>
      </div>
      <input id="joueur_poids"
             v-model="dataForm.poids"
             class="form-control"
             name="joueur_poids"
             placeholder="Entrez le poids du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label id="date_naissance" class="input-group-text" for="joueur_date_naissance">Date de naissance</label>
      </div>
      <input id="joueur_date_naissance"
             v-model="dataForm.date_naissance"
             class="form-control"
             name="joueur_date_naissance"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label id="dossard" class="input-group-text" for="joueur_dossard">Dossard</label>
      </div>
      <input id="joueur_dossard"
             v-model="dataForm.dossard"
             class="form-control"
             name="joueur_dossard"
             placeholder="Entrez le numero du dossard du joueur"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label id="photo_passeport" class="input-group-text" for="fileToUpload">Photo passeport</label>
      </div>
      <input id="fileToUpload"
             ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_nationalite">Nationalité</label>
      </div>
      <select id="joueur_nationalite"
              v-model="dataForm.nationalite"
              class="custom-select"
              name="joueur_nationalite">
        <option :key="'nationalite'+idx"
                :value="nationalite.value"
                v-for="(nationalite, idx) in getNationalites">{{ nationalite.nationalites }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_equipe">Equipe</label>
      </div>
      <select id="joueur_equipe"
              v-model="dataForm.equipe_id"
              class="custom-select"
              name="joueur_equipe">
        <option :key="equipe.equipe_id.slice(5,15)"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_date_debut_contrat">Date début et fin du contrat</label>
        <label class="input-group-text" for="joueur_date_fin_contrat"></label>
      </div>
      <input id="joueur_date_debut_contrat"
             v-model="dataForm.date_debut_contrat"
             class="form-control"
             name="joueur_date_debut_contrat"
             type="date">
      <input id="joueur_date_fin_contrat"
             v-model="dataForm.date_fin_contrat"
             class="form-control"
             name="joueur_date_fin_contrat"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="joueur_commentaires">Commentaires</label>
      </div>
      <textarea id="joueur_commentaires"
                v-model="dataForm.commentaires"
                class="form-control"
                name="joueur_commentaires"
                placeholder="Entrez vos commentaires sur le joueur">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_telephone_1">Telephones</label>
        <label class="input-group-text" for="joueur_telephone_2"></label>
      </div>
      <input id="joueur_telephone_1"
             v-model="dataForm.telephones"
             class="form-control"
             name="joueur_telephone_1"
             placeholder="Entrez le numéro prncipal du joueur"
             type="tel">
      <input id="joueur_telephone_2"
             v-model="dataForm.telephones"
             class="form-control"
             name="joueur_telephone_2"
             placeholder="Entrez le numéro secondaire du joueur"

             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_email">Email</label>
      </div>
      <input id="joueur_email"
             v-model="dataForm.email"
             class="form-control"
             name="joueur_email"
             placeholder="Entrez l'adresse email du joueur"
             type="email">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_surnom">Surnom</label>
      </div>
      <input id="joueur_surnom"
             v-model="dataForm.surnom"
             class="form-control"
             name="joueur_surnom"
             placeholder="Entrez le sobriqué ou surnom du joueur"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="joueur_type_contrat">Type des contrats</label>
      </div>
      <select id="joueur_type_contrat"
              v-model="dataForm.type_contrat"
              class="custom-select"
              name="joueur_type_contrat">
        <option :key="'type_contrat'+idx"
                :value="type_contrat"
                v-for="(type_contrat, idx) in getTypesContratJoueurs">{{ type_contrat }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="mr-3">Selectionné ? </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.selectionne"
               name="joueur_selectionne"
               id="joueur_selectionne_oui" value="oui">
        <label class="form-check-label rounded pl-2 pr-2" for="joueur_selectionne_oui">OUI</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input"
               type="radio"
               v-model="dataForm.selectionne"
               name="joueur_selectionne"
               id="joueur_selectionne_non"
               value="non">
        <label class="form-check-label rounded pl-2 pr-2" for="joueur_selectionne_non">NON</label>
      </div>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      equipes: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        postnom: '',
        prenom: '',
        poste: '',
        taille: '',
        poids: '',
        date_naissance: '',
        dossard: '',
        photo_passeport: '',
        nationalite: 'Congolais - Kinshasa',
        equipe_id: '',
        date_debut_contrat: '',
        date_fin_contrat: '',
        commentaires: '',
        telephones: '',
        email: '',
        surnom: '',
        type_contrat: '',
        selectionne: 'oui',
        table: 'joueurs',
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
      'axiosPostFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFile () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom && this.dataForm.postnom && this.dataForm.prenom){
        fileName = this.dataForm.prenom.toLowerCase() + '_' +
            this.dataForm.postnom.toLowerCase() + '_' +
            this.dataForm.nom.toLowerCase() + '_' + Math.floor(Math.random() * 1000000) + 1;
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "joueurs")
      if(this.file) {
        this.axiosPostFileData(formData)
            .then(data => {
              this.dataForm.photo_passeport = data[2];
            })
            .catch(data => {})
      }
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Joueur ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion du joueur !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du joueur !"
          })

    },
    onSubmit() {
      this.uploadFile()
    }
  },
  computed: {
    ...mapGetters([
        'getNationalites',
        'getTypesContratJoueurs',
    ])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/joueurs/components/Create.vue